import { useEffect } from 'react';

export type IndexShortcutAction = 'audit-run' | 'export';

/** Global workspace shortcuts (F9 audit, F12 export). */
export function useIndexShortcuts() {
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if (e.key === 'F9') {
        e.preventDefault();
        window.dispatchEvent(
          new CustomEvent('index:shortcut', { detail: 'audit-run' satisfies IndexShortcutAction }),
        );
      }
      if (e.key === 'F12') {
        e.preventDefault();
        window.dispatchEvent(
          new CustomEvent('index:shortcut', { detail: 'export' satisfies IndexShortcutAction }),
        );
      }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, []);
}

export function onIndexShortcut(
  action: IndexShortcutAction,
  callback: () => void,
): () => void {
  const handler = (e: Event) => {
    const detail = (e as CustomEvent<IndexShortcutAction>).detail;
    if (detail === action) callback();
  };
  window.addEventListener('index:shortcut', handler);
  return () => window.removeEventListener('index:shortcut', handler);
}
